import React from 'react';
import {useDroppable} from "@dnd-kit/core";
import EmployeeCard from "./EmployeeCard.js";
import Loader from "../BlueButton/Loader.js";

const TeamColumn = ({ team, employees,isLoading }) => {
    const { setNodeRef } = useDroppable({ id: String(team.id) });

    return (
        <div ref={setNodeRef} style={{
            flex: 1,
            backgroundColor: '#f4f4f4',
            padding: '1rem',
            borderRadius: '8px',
            minHeight: '300px'
        }}>

            <h3>{team.name}</h3>
            {isLoading ? (
                <div className="absolute inset-0 bg-white/80 flex justify-center items-center z-10">
                    <Loader type="Oval" color="#fff" height={15} width={15}/>
                </div>
            ):employees.map(emp => (
                <EmployeeCard key={emp.id} employee={emp} />
            ))}
        </div>
    );
};

export default TeamColumn;